import { useEffect, memo } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Drawer, Typography, Avatar } from '@mui/material';
// mock
import MOCK_ACCOUNT from '../../../_mock/account.mock';
// components
import Scrollbar from '../../../components/scrollbar';
import { NavSectionVertical } from '../../@header/navbar';
import useCollapseDrawer from '../../../hooks/useCollapseDrawer';
import { HEADER, NAVBAR } from '../../../store/constant';
import { getAssetsUrl, getImageUrl } from '../../../utils/@helper/file.helper';
import { SvgChevronRightFill, SvgWorldFill } from '../../../components/SvgIcons';
import LanguagePopup from '../../../components/drawer/language';


//

// ==============================|| DRAWER - MINI STYLED ||============================== //

const openedMixin = (theme) => ({
  '&:nth-of-type(1)': {
    width: '100%',
    transform: 'rotate(45deg)',
    transformOrigin: '2px 2px',
  },
  '&:nth-of-type(2)': {
    width: '30px',
    opacity: 0,
  },
  '&:nth-of-type(3)': {
    width: '30px',
    transform: 'rotate(-45deg)',
    transformOrigin: '0px 0px',
  }
});

const closedMixin = () => ({});
const HamburgerIcon = styled(Box, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignItems: 'center',
  width: 30,
  cursor: 'pointer',
  '& .Sim-icon-line': {
    width: 30,
    height: 2,
    backgroundColor: theme.palette.background.paper,
    display: 'block',
    opacity: 1,
    visibility: 'visible',
    transition: 'all 0.3s',
    margin: '4px 0',
    position: 'relative',
    ...(open && {
      ...openedMixin(theme)
    }),
    // ...(!open && {
    //   ...closedMixin(theme),
    // })
  },
}));


const HamburgerMenus = ({ open, onClick }) => {
  return (
    <HamburgerIcon open={open} onClick={onClick}>
      <Box className={'Sim-icon-line'} />
      <Box className={'Sim-icon-line'} />
      <Box className={'Sim-icon-line'} />
    </HamburgerIcon>
  )
}

// ----------------------------------------------------------------------

const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ==============================|| DRAWER - NAV BAR ||============================== //

HeaderVertical.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

function HeaderVertical({ profile, navigations, openNav, onOpenNav, onCloseNav }) {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const { isCollapse, collapseClick, collapseHover, onToggleCollapse, onHoverEnter, onHoverLeave } =
    useCollapseDrawer();

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box sx={{ my: 3, mx: 2.5 }}>
        <Link underline="none">
          <StyledAccount>
            <Avatar src={profile?.avatar ? getImageUrl(profile?.avatar) : getAssetsUrl('images/avatars/avatar_ellipse.svg')} alt="photoURL" />

            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'common.white' }}>
                {profile?.realname}
              </Typography>

              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {profile?.email}
              </Typography>
            </Box>
          </StyledAccount>
        </Link>
      </Box>

      <NavSectionVertical navConfig={navigations} isCollapse={isCollapse} />

    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAVBAR.DASHBOARD_WIDTH },
      }}
    >
      {/* <HamburgerMenus open={open} onClick={() => dispatch(openMenuDrawer(!open))} /> */}
      <Box height={'100%'} display={'flex'} alignItems={'center'}>
        <HamburgerMenus open={openNav} onClick={onOpenNav} />
      </Box>
      <Drawer
        hideBackdrop
        open={openNav}
        onClose={onCloseNav}
        disableScrollLock={Boolean(true)}
        ModalProps={{
          keepMounted: true,
          sx: {
            top: `${HEADER.MOBILE_HEIGHT}px`,
          }
        }}
        PaperProps={{
          sx: {
            mt: `${HEADER.MOBILE_HEIGHT}px`,
            width: '100%',
            bgcolor: 'background.default',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundOrigin: 'border-box',
            backgroundImage: `url('https://www.honhai.com/img/index/menu-bg-m.png')`
          },
        }}
      >
        <Box height={`calc(100% - 145px)`}>
          {renderContent}
        </Box>
        <LanguagePopup />
      </Drawer>
    </Box>
  );
}
export default memo(HeaderVertical);
